import alert from "bootstrap/js/src/alert";

jQuery(function ($) {
    function InitDropdown() {
        setTimeout(function () {
            $("select[name='contact[object]']").select2({
                placeholder: "Votre demande concerne",
            });
            // Set default value null
            $(".select-select2").val(null).trigger("change");
            $(".select-select2").on("select2:select", function (e) {
                $(this).parent().addClass("select-filled");
            });

            // Set default motif if provided
            let motif = $("#motif-hidden-field").data("motif");
            if(motif){
                $("#contact_object").val(motif).trigger("change")
                $(".is-filled").addClass("select-filled");
            }

        }, 0)
    }
    InitDropdown();
});

$('#contact_object').change(function () {
    var objetSelect = $(this);

    $(".loader_div").fadeIn();
    $.ajax({
        url: "/get-message-contact",
        type: "GET",
        dataType: "JSON",
        data: {
            title: objetSelect.val()
        },
        success: function (data) {
            if ($.isEmptyObject(data)) {
                console.log(data);

            }else{
                $("#contact_message").val(data);
                $(".loader_div").fadeOut();
            }
        },
        error: function (err) {
            $('.loading-ajax').fadeOut();
            $("#contact_message").val('');
            $(".loader_div").fadeOut();
        }
    });
});